import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Card,
  Col,
  Modal,
  Form,
  Button,
  Offcanvas,
  Badge,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import Breadcrumb from "Common/BreadCrumb";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Flatpickr from "react-flatpickr";
import { useFetchClassesQuery } from "features/classes/classeSlice";
import { useFetchEnseignantsQuery } from "features/enseignants/enseignantSlice";
import {
  useAddExerciceMutation,
  useDeleteExerciceMutation,
  useFetchExercicesQuery,
  useBulkDeleteExercicesMutation,
} from "features/exercices/exerciceSlice";
import Select from "react-select";
import {
  useFetchMatieresByClasseIdQuery,
  useFetchMatieresQuery,
} from "features/matieres/matiereSlice";
import { French } from "flatpickr/dist/l10n/fr";
import { formatDate, formatTime } from "helpers/data_time_format";
import { convertToBase64 } from "helpers/base64_convert";
import {
  useFetchSmsSettingsQuery,
  useUpdateSmsSettingByIdMutation,
} from "features/smsSettings/smsSettings";
import UpdateExercice from "./UpdateExercice";

const Exercices = () => {
  const { data = [] } = useFetchExercicesQuery();
  const { data: AllClasses = [] } = useFetchClassesQuery();

  const { data: AllEnseignants = [] } = useFetchEnseignantsQuery();

  const { data: AllSmsSettings, isLoading = [] } = useFetchSmsSettingsQuery();

  const { data: AllMatieres = [] } = useFetchMatieresQuery();

  const [deleteExercice] = useDeleteExerciceMutation();
  const [bulkDeleteExercices] = useBulkDeleteExercicesMutation();

  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const handleRowSelected = (state: any) => {
    setSelectedRows(state.selectedRows);
  };

  const handleBulkDelete = async () => {
    if (selectedRows.length === 0) return;
    const result = await swalWithBootstrapButtons.fire({
      title: "Suppression groupée",
      text: `Supprimer ${selectedRows.length} exercice(s) sélectionné(s) ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Oui, supprimer !",
      cancelButtonText: "Annuler",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      const ids = selectedRows.map((r: any) => r._id);
      await bulkDeleteExercices(ids).unwrap();
      setToggleCleared(!toggleCleared);
      setSelectedRows([]);
      notifySuccess(`${ids.length} exercice(s) supprimé(s)`);
    }
  };

  const [showObservation, setShowObservation] = useState<boolean>(false);

  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedBadgeDate, setSelectedBadgeDate] = useState<Date | null>(null);
  const handleDateChange = (selectedDates: Date[]) => {
    setSelectedDate(selectedDates[0]);
  };
  const handleBadgeDateChange = (selectedDates: Date[]) => {
    setSelectedBadgeDate(selectedDates[0]);
  };
  const notifySuccess = (msg: string) => {
    Swal.fire({
      position: "center",
      icon: "success",
      title: msg,
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const notifyError = (err: any) => {
    Swal.fire({
      position: "center",
      icon: "error",
      title: `Une erreur est survenue: ${err}`,
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });

  const AlertDelete = async (_id: any) => {
    swalWithBootstrapButtons
      .fire({
        title: "Etes-vous sûr?",
        text: "Vous ne pouvez pas revenir en arrière?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, supprime-le !",
        cancelButtonText: "Non, annuler !",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteExercice(_id);
          swalWithBootstrapButtons.fire(
            "Supprimé !",
            "Le travail à la maison est supprimé.",
            "success"
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire(
            "Annulé",
            "Le travail à la maison est en sécurité :)",
            "info"
          );
        }
      });
  };

  const [selectedClasse, setSelectedClasse] = useState<string>("");

  const handleSelectClasse = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedClasse(value);
  };

  const [selectedPar, setSelectedPar] = useState<string>("");

  const handleSelectPar = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedPar(value);
  };

  const [modal_AddObservation, setmodal_AddObservation] =
    useState<boolean>(false);
  function tog_AddObservation() {
    setmodal_AddObservation(!modal_AddObservation);
  }

  const [modal_UpdateExercice, setmodal_UpdateExercice] =
    useState<boolean>(false);
  function tog_UpdateExercice() {
    setmodal_UpdateExercice(!modal_UpdateExercice);
  }

  const optionColumnsTable = [...AllClasses].sort((a: any, b: any) => (a.nom_classe || "").localeCompare(b.nom_classe || "", "fr")).map((classe: any) => ({
    value: classe?._id!,
    label: classe?.nom_classe!,
  }));

  const [selectedColumnValues, setSelectedColumnValues] = useState<any[]>([]);

  const handleSelectValueColumnChange = (selectedOption: any) => {
    const values = selectedOption.map((option: any) => option.value);
    setSelectedColumnValues(values);
  };

  const [selectedMatiere, setSelectedMatiere] = useState<string>("");

  const handleSelectMatiere = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedMatiere(value);
  };

  const [updateAvisSmsSetting] = useUpdateSmsSettingByIdMutation();
  const [formData, setFormData] = useState({
    id: "",
    status: "",
  });

  useEffect(() => {
    if (AllSmsSettings !== undefined && isLoading === false) {
      const devoir_sms_setting = AllSmsSettings?.filter(
        (parametre) => parametre.service_name === "Travail à la maison"
      );
      setFormData((prevState) => ({
        ...prevState,
        id: devoir_sms_setting[0]?._id!,
        status: devoir_sms_setting[0]?.sms_status!,
      }));
    }
  }, [AllSmsSettings, isLoading]);

  const onChangeDocumentSmsSetting = () => {
    let updateData = {
      id: formData.id,
      status: formData.status === "1" ? "0" : "1",
    };
    updateAvisSmsSetting(updateData)
      .then(() =>
        setFormData((prevState) => ({
          ...prevState,
          status: formData.status === "1" ? "0" : "1",
        }))
      )
      .then(() =>
        notifySuccess(
          "Paramètre Travail à la maison SMS a été modifié avec succès"
        )
      );
  };

  const [createObservation] = useAddExerciceMutation();

  const initialObservation = {
    matiere: "",
    classes: "",
    desc: "",
    creation_date: "",
    badge_date: "",
    fichier_base64_string: "",
    fichier_extension: "",
    fichier: "",
    enseignant: "",
  };

  const [observation, setObservation] = useState(initialObservation);

  const {
    matiere,
    classes,
    desc,
    creation_date,
    badge_date,
    fichier_base64_string,
    fichier_extension,
    fichier,
    enseignant,
  } = observation;

  const onChangeObservation = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setObservation((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };

  const handleFileUploadFile = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = (
      document.getElementById("fichier_base64_string") as HTMLFormElement
    ).files[0];
    if (file) {
      const { base64Data, extension } = await convertToBase64(file);
      const file_observation = base64Data + "." + extension;
      setObservation({
        ...observation,
        fichier: file_observation,
        fichier_base64_string: base64Data,
        fichier_extension: extension,
      });
    }
  };

  const onSubmitObservation = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      observation["creation_date"] = formatDate(selectedDate);
      observation["badge_date"] = formatDate(selectedBadgeDate);
      observation["classes"] = selectedClasse;
      observation["enseignant"] = selectedPar;
      observation["matiere"] = selectedMatiere;
      createObservation(observation)
        .then(() =>
          notifySuccess("Le travail à la maison a été créée avec succès")
        )
        .then(() => setObservation(initialObservation));
    } catch (error) {
      notifyError(error);
    }
  };

  // Filters
  const [filterMatiere, setFilterMatiere] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  // Stats
  const stats = useMemo(() => {
    const matiereCount: Record<string, number> = {};
    data.forEach((ex: any) => {
      const m = ex?.matiere || "Autre";
      matiereCount[m] = (matiereCount[m] || 0) + 1;
    });
    return { total: data.length, matiereCount };
  }, [data]);

  const getFilteredExercices = () => {
    let filteredExercices = [...data];

    if (filterMatiere) {
      filteredExercices = filteredExercices.filter(
        (exercice: any) => exercice?.matiere === filterMatiere
      );
    }

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filteredExercices = filteredExercices.filter(
        (exercice: any) =>
          exercice?.matiere?.toLowerCase().includes(term) ||
          exercice?.classes?.nom_classe?.toLowerCase().includes(term) ||
          exercice?.creation_date?.toLowerCase().includes(term) ||
          exercice?.badge_date?.toLowerCase().includes(term) ||
          exercice?.enseignant?.toLowerCase().includes(term) ||
          exercice?.desc?.toLowerCase().includes(term)
      );
    }

    return filteredExercices.reverse();
  };

  const columns = [
    {
      name: <span className="fw-semibold fs-13">Matière</span>,
      selector: (row: any) => row?.matiere!,
      cell: (row: any) => (
        <Badge bg="info-subtle" text={"info" as any} className="fs-12 px-2 py-1">
          <i className="ri-book-2-line me-1" />
          {row?.matiere}
        </Badge>
      ),
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Classe</span>,
      selector: (row: any) => row?.classes?.nom_classe!,
      cell: (row: any) => (
        <span className="fs-13">
          <i className="ri-group-line me-1 text-primary" />
          {row?.classes?.nom_classe}
        </span>
      ),
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Date de création</span>,
      selector: (row: any) => row.creation_date,
      cell: (row: any) => (
        <span className="text-muted fs-13">
          <i className="ri-calendar-line me-1 text-primary" />
          {row.creation_date}
        </span>
      ),
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Date de remis</span>,
      selector: (row: any) => row.badge_date,
      cell: (row: any) => (
        <span className="text-muted fs-13">
          <i className="ri-calendar-check-line me-1 text-success" />
          {row.badge_date}
        </span>
      ),
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Enseignant</span>,
      selector: (row: any) => row.enseignant,
      cell: (row: any) => (
        <span className="fs-13">
          <i className="ri-user-settings-line me-1 text-muted" />
          {row.enseignant}
        </span>
      ),
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Actions</span>,
      cell: (row: any) => (
        <div className="d-flex gap-1">
          <Link
            to="#"
            state={row}
            className="btn btn-soft-info btn-sm btn-icon"
            onClick={() => setShowObservation(true)}
            title="Voir détails"
          >
            <i className="ri-eye-line" />
          </Link>
          <Link
            to="#"
            state={row}
            className="btn btn-soft-success btn-sm btn-icon"
            onClick={() => tog_UpdateExercice()}
            title="Modifier"
          >
            <i className="ri-edit-2-line" />
          </Link>
          <button
            className="btn btn-soft-danger btn-sm btn-icon"
            onClick={() => AlertDelete(row._id)}
            title="Supprimer"
          >
            <i className="ri-delete-bin-2-line" />
          </button>
        </div>
      ),
    },
  ];

  const observationLocation = useLocation();

  const openFileInNewTab = (fileUrl: string, fileName: string) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.target = "_blank";
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleButtonClick = () => {
    const fileUrl = `${process.env.REACT_APP_BASE_URL}/exerciceFiles/${observationLocation.state.fichier}`;
    const fileName = "sample.pdf";

    openFileInNewTab(fileUrl, fileName);
  };

  const { data: allMatieresByClasseId = [] } =
    useFetchMatieresByClasseIdQuery(selectedClasse, { skip: !selectedClasse });

  // Unique matieres for filter dropdown
  const uniqueMatieres = useMemo(() => {
    const set = new Set<string>();
    data.forEach((ex: any) => {
      if (ex?.matiere) set.add(ex.matiere);
    });
    return Array.from(set).sort();
  }, [data]);

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f3f6f9",
        fontWeight: "600",
        fontSize: "13px",
        color: "#495057",
        borderBottom: "2px solid #e9ebec",
      },
    },
    rows: {
      style: {
        fontSize: "13px",
        "&:hover": {
          backgroundColor: "#f3f6f9",
        },
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #e9ebec",
      },
    },
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Travail à la maison" pageTitle="Tableau de bord" />

          {/* KPI Cards */}
          <Row className="mb-3">
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm cursor-pointer" onClick={() => setFilterMatiere("")}>
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-primary-subtle text-primary rounded-circle fs-3">
                        <i className="ri-book-open-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Total Exercices</p>
                      <h4 className="mb-0">{stats.total}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-success-subtle text-success rounded-circle fs-3">
                        <i className="ri-booklet-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Matières</p>
                      <h4 className="mb-0 text-success">{uniqueMatieres.length}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-warning-subtle text-warning rounded-circle fs-3">
                        <i className="ri-group-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Classes</p>
                      <h4 className="mb-0 text-warning">
                        {new Set(data.map((ex: any) => ex?.classes?.nom_classe).filter(Boolean)).size}
                      </h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-info-subtle text-info rounded-circle fs-3">
                        <i className="ri-chat-settings-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">SMS</p>
                      <div className="form-check form-switch mb-0">
                        <input
                          key={formData?.id!}
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id={formData.id}
                          checked={formData.status === "1"}
                          onChange={() => onChangeDocumentSmsSetting()}
                        />
                        {formData.status === "0" ? (
                          <span className="badge bg-warning-subtle text-warning">Désactivé</span>
                        ) : (
                          <span className="badge bg-success-subtle text-success">Activé</span>
                        )}
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Data Table */}
          <Col lg={12}>
            <Card className="border-0 shadow-sm">
              <Card.Header className="border-bottom-dashed bg-white">
                <Row className="g-3 align-items-center">
                  <Col lg={4} md={6}>
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Rechercher par matière, classe, enseignant..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </Col>
                  <Col lg={3} md={3}>
                    <select
                      className="form-select"
                      value={filterMatiere}
                      onChange={(e) => setFilterMatiere(e.target.value)}
                    >
                      <option value="">Toutes les matières</option>
                      {uniqueMatieres.map((m) => (
                        <option value={m} key={m}>{m}</option>
                      ))}
                    </select>
                  </Col>
                  <Col lg={5} md={3} className="d-flex justify-content-end gap-2">
                    {(filterMatiere || searchTerm) && (
                      <Button
                        variant="soft-secondary"
                        size="sm"
                        onClick={() => { setFilterMatiere(""); setSearchTerm(""); }}
                      >
                        <i className="ri-filter-off-line me-1" />
                        Réinitialiser
                      </Button>
                    )}
                    <Button
                      variant="primary"
                      onClick={() => tog_AddObservation()}
                      className="d-flex align-items-center gap-1"
                    >
                      <i className="ri-add-line fs-16" />
                      Ajouter Exercice
                    </Button>
                  </Col>
                </Row>
              </Card.Header>
              {selectedRows.length > 0 && (
                <div className="bg-primary-subtle border-bottom p-3 d-flex align-items-center gap-3">
                  <span className="fw-semibold text-primary">
                    {selectedRows.length} sélectionné(s)
                  </span>
                  <Button variant="danger" size="sm" onClick={handleBulkDelete} className="d-flex align-items-center gap-1">
                    <i className="ri-delete-bin-2-line" />
                    Supprimer
                  </Button>
                  <Button variant="soft-secondary" size="sm" onClick={() => { setToggleCleared(!toggleCleared); setSelectedRows([]); }}>
                    <i className="ri-close-line me-1" />
                    Annuler
                  </Button>
                </div>
              )}
              <Card.Body className="p-0">
                <DataTable
                  columns={columns}
                  data={getFilteredExercices()}
                  selectableRows
                  selectableRowsVisibleOnly
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                  pagination
                  paginationPerPage={15}
                  paginationRowsPerPageOptions={[10, 15, 25, 50]}
                  customStyles={customStyles}
                  noDataComponent={
                    <div className="text-center py-5">
                      <i className="ri-book-open-line fs-1 text-muted d-block mb-2" />
                      <p className="text-muted mb-0">Aucun exercice trouvé</p>
                    </div>
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: "Lignes par page",
                    rangeSeparatorText: "sur",
                  }}
                  highlightOnHover
                  responsive
                />
              </Card.Body>
            </Card>
          </Col>

          {/* Add Modal */}
          <Modal
            className="fade"
            show={modal_AddObservation}
            onHide={() => {
              tog_AddObservation();
            }}
            centered
            size="lg"
          >
            <Modal.Header closeButton className="bg-primary-subtle">
              <h5 className="modal-title d-flex align-items-center gap-2">
                <i className="ri-add-circle-line fs-20" />
                Ajouter Travail à la maison
              </h5>
            </Modal.Header>
            <Modal.Body className="px-4 py-3">
              <Form className="create-form" onSubmit={onSubmitObservation}>
                <p className="text-muted fs-12 text-uppercase fw-semibold mb-3">
                  <i className="ri-information-line me-1" />
                  Informations générales
                </p>
                <Row className="g-3 mb-4">
                  <Col md={6}>
                    <Form.Label htmlFor="classe" className="fw-medium">
                      <i className="ri-group-line me-1 text-primary" />
                      Classe <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      options={[...AllClasses].sort((a: any, b: any) => (a.nom_classe || "").localeCompare(b.nom_classe || "", "fr")).map((classe) => ({
                        value: classe?._id!,
                        label: classe.nom_classe,
                      }))}
                      onChange={(opt: any) => { const e = { target: { value: opt?.value || "" } } as any; handleSelectClasse(e); }}
                      placeholder="Rechercher une classe..."
                      isClearable
                      isSearchable
                      noOptionsMessage={() => "Aucune classe trouvée"}
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Label htmlFor="matiere" className="fw-medium">
                      <i className="ri-book-2-line me-1 text-info" />
                      Matière <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      options={allMatieresByClasseId.flatMap((matiere) =>
                        matiere.matieres.map((m) => ({
                          value: m.nom_matiere,
                          label: m.nom_matiere,
                        }))
                      ).sort((a, b) => a.label.localeCompare(b.label, "fr"))}
                      onChange={(opt: any) => { const e = { target: { value: opt?.value || "" } } as any; handleSelectMatiere(e); }}
                      placeholder="Rechercher une matière..."
                      isClearable
                      isSearchable
                      noOptionsMessage={() => "Aucune matière trouvée"}
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Label htmlFor="par" className="fw-medium">
                      <i className="ri-user-settings-line me-1 text-success" />
                      Enseignant <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      options={[...AllEnseignants].sort((a: any, b: any) => (`${a.nom_enseignant} ${a.prenom_enseignant}`).localeCompare(`${b.nom_enseignant} ${b.prenom_enseignant}`, "fr")).map((enseignant: any) => ({
                        value: `${enseignant.nom_enseignant} ${enseignant.prenom_enseignant}`,
                        label: `${enseignant.nom_enseignant} ${enseignant.prenom_enseignant}`,
                      }))}
                      onChange={(opt: any) => { const e = { target: { value: opt?.value || "" } } as any; handleSelectPar(e); }}
                      placeholder="Rechercher un enseignant..."
                      isClearable
                      isSearchable
                      noOptionsMessage={() => "Aucun enseignant trouvé"}
                    />
                  </Col>
                </Row>

                <hr className="text-muted" />
                <p className="text-muted fs-12 text-uppercase fw-semibold mb-3">
                  <i className="ri-calendar-line me-1" />
                  Dates
                </p>
                <Row className="g-3 mb-4">
                  <Col md={6}>
                    <Form.Label htmlFor="date" className="fw-medium">
                      <i className="ri-calendar-event-line me-1 text-primary" />
                      Date de création <span className="text-danger">*</span>
                    </Form.Label>
                    <Flatpickr
                      className="form-control"
                      placeholder="Sélectionner la date"
                      onChange={handleDateChange}
                      options={{
                        dateFormat: "d M, Y",
                        locale: French,
                      }}
                      id="date"
                      name="date"
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Label htmlFor="badge_date" className="fw-medium">
                      <i className="ri-calendar-check-line me-1 text-success" />
                      Date de remise <span className="text-danger">*</span>
                    </Form.Label>
                    <Flatpickr
                      className="form-control"
                      placeholder="Sélectionner la date"
                      onChange={handleBadgeDateChange}
                      options={{
                        dateFormat: "d M, Y",
                        locale: French,
                      }}
                      id="badge_date"
                      name="badge_date"
                    />
                  </Col>
                </Row>

                <hr className="text-muted" />
                <p className="text-muted fs-12 text-uppercase fw-semibold mb-3">
                  <i className="ri-attachment-2 me-1" />
                  Détails & pièce jointe
                </p>
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Label htmlFor="desc" className="fw-medium">
                      <i className="ri-file-text-line me-1 text-muted" />
                      Description
                    </Form.Label>
                    <textarea
                      className="form-control"
                      id="desc"
                      name="desc"
                      value={observation.desc}
                      onChange={onChangeObservation}
                      rows={3}
                      placeholder="Détails du travail à la maison..."
                    />
                  </Col>
                  <Col md={12}>
                    <Form.Label htmlFor="fichier_base64_string" className="fw-medium">
                      <i className="ri-attachment-2 me-1 text-warning" />
                      Fichier joint
                    </Form.Label>
                    <div className="input-group">
                      <span className="input-group-text bg-light">
                        <i className="ri-upload-cloud-2-line text-muted" />
                      </span>
                      <input
                        className="form-control"
                        type="file"
                        id="fichier_base64_string"
                        name="fichier_base64_string"
                        onChange={(e) => handleFileUploadFile(e)}
                      />
                    </div>
                    <small className="text-muted">PDF, Image ou document (optionnel)</small>
                  </Col>
                </Row>
                <div className="hstack gap-2 justify-content-end border-top mt-4 pt-3">
                  <Button
                    variant="light"
                    onClick={() => {
                      tog_AddObservation();
                      setObservation(initialObservation);
                    }}
                  >
                    <i className="ri-close-line me-1" />
                    Annuler
                  </Button>
                  <Button
                    onClick={() => {
                      tog_AddObservation();
                    }}
                    type="submit"
                    variant="primary"
                  >
                    <i className="ri-check-line me-1" />
                    Enregistrer
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>

          {/* Update Modal */}
          <Modal
            className="fade"
            show={modal_UpdateExercice}
            onHide={() => {
              tog_UpdateExercice();
            }}
            centered
            size="lg"
          >
            <Modal.Header closeButton className="bg-success-subtle">
              <h5 className="modal-title">
                <i className="ri-edit-2-line me-2" />
                Modifier Exercice
              </h5>
            </Modal.Header>
            <Modal.Body>
              <UpdateExercice
                modal_UpdateExercice={modal_UpdateExercice}
                setmodal_UpdateExercice={setmodal_UpdateExercice}
              />
            </Modal.Body>
          </Modal>
        </Container>

        {/* Detail Offcanvas */}
        <Offcanvas
          show={showObservation}
          onHide={() => setShowObservation(false)}
          placement="end"
          style={{ width: "420px" }}
        >
          <Offcanvas.Header closeButton className="border-bottom bg-light">
            <Offcanvas.Title className="d-flex align-items-center gap-2">
              <i className="ri-book-open-line text-primary fs-20" />
              Détails du travail à la maison
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="mb-4">
              <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                Classe
              </label>
              <div className="d-flex align-items-center gap-2">
                <div className="avatar-xs">
                  <div className="avatar-title bg-primary-subtle text-primary rounded-circle">
                    <i className="ri-group-line" />
                  </div>
                </div>
                <span className="fw-medium">{observationLocation?.state?.classes?.nom_classe}</span>
              </div>
            </div>

            <div className="mb-4">
              <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                Matière
              </label>
              <Badge bg="info-subtle" text={"info" as any} className="fs-13 px-3 py-2">
                <i className="ri-book-2-line me-1" />
                {observationLocation?.state?.matiere}
              </Badge>
            </div>

            <div className="mb-4">
              <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                Description
              </label>
              <p className="mb-0">{observationLocation?.state?.desc || "—"}</p>
            </div>

            <Row className="mb-4 g-3">
              <Col xs={6}>
                <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                  Date création
                </label>
                <span>
                  <i className="ri-calendar-line me-1 text-primary" />
                  {observationLocation?.state?.creation_date}
                </span>
              </Col>
              <Col xs={6}>
                <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                  Date de remis
                </label>
                <span>
                  <i className="ri-calendar-check-line me-1 text-success" />
                  {observationLocation?.state?.badge_date}
                </span>
              </Col>
            </Row>

            <div className="mb-4">
              <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                Enseignant
              </label>
              <span>
                <i className="ri-user-settings-line me-1 text-muted" />
                {observationLocation?.state?.enseignant}
              </span>
            </div>

            {observationLocation?.state?.fichier && observationLocation.state.fichier !== "" && (
              <div>
                <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                  Fichier joint
                </label>
                <Button variant="soft-danger" size="sm" onClick={handleButtonClick} className="d-flex align-items-center gap-1">
                  <i className="ri-file-pdf-line fs-16" />
                  Ouvrir le fichier
                </Button>
              </div>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </React.Fragment>
  );
};
export default Exercices;
